/* eslint-disable no-param-reassign */
import {IElement} from '../../../incase-domain/elements';

function start(event: Interact.ResizeEvent, element: IElement, elementPosition: {x: number; y: number}): void {
    const targetEl = event.target as HTMLElement;
    const {height, width} = element;

    targetEl.style.userSelect = 'none';

    const data = {
        ...elementPosition,
        height: height || '0%',
        width: width || '0%',
    };

    setDatasetAttrs(targetEl, data);
    setStyleAttrs(targetEl, data);
}

function move(event: Interact.ResizeEvent, clientWidth: number, clientHeight: number): void {
    const targetEl = event.target as HTMLElement;

    const data = {
        x: Number(targetEl.dataset.x),
        y: Number(targetEl.dataset.y),
        height: targetEl.dataset.height ?? '10%',
        width: targetEl.dataset.width ?? '20%',
    };

    // translate when resizing from top or left edges
    if (event.edges?.top && event.deltaRect) {
        data.y -= event.deltaRect.height;

        if (data.y < 0) {
            data.y = 0;
        }
    }

    if (event.edges?.left && event.deltaRect) {
        data.x -= event.deltaRect.width;

        if (data.x < 0) {
            data.x = 0;
        }
    }

    data.height = `${(event.rect.height / clientHeight) * 100}%`;
    data.width = `${(event.rect.width / clientWidth) * 100}%`;

    setDatasetAttrs(targetEl, data);
    setStyleAttrs(targetEl, data);
}

function end(
    event: Interact.ResizeEvent,
    elementPosition: {x: number; y: number},
    clientWidth: number,
    clientHeight: number,
    updateElement: (element: Partial<IElement>) => void
): void {
    const {x, y} = elementPosition;
    const targetEl = event.target as HTMLElement;

    const data = {
        x: (x / clientWidth) * 100,
        y: (y / clientHeight) * 100,
        width: targetEl.dataset.width ?? '0%',
        height: targetEl.dataset.height ?? '0%',
    };

    const updatedElement = {
        xPosition: data.x,
        yPosition: data.y,
        width: data.width,
        height: data.height,
    } as Partial<IElement>;

    updateElement(updatedElement);
}

function setStyleAttrs(
    targetEl: HTMLElement,
    d: {
        x: number;
        y: number;
        height: string;
        width: string;
    }
): void {
    targetEl.style.left = `${d.x}px`;
    targetEl.style.top = `${d.y}px`;
    targetEl.style.height = d.height;
    targetEl.style.width = d.width;
}

function setDatasetAttrs(
    targetEl: HTMLElement,
    d: {
        x: number;
        y: number;
        height: string;
        width: string;
    }
): void {
    targetEl.dataset.x = d.x.toString();
    targetEl.dataset.y = d.y.toString();
    targetEl.dataset.height = d.height;
    targetEl.dataset.width = d.width;
}

export const resize = {start, move, end};
